export default __webpack_public_path__ + "static/media/sports-background-yellowy.fdb95d46.png";